import * as e from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/Shield.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: i }));
o.displayName = "ShieldIcon";
const s = o;
export {
  s as Shield,
  o as ShieldIcon
};
